import ShowOrder from '@/modules/HuntingLicenses/LicenseOrder/ShowOrder.vue';
import LicenseOrderCopyShow from '@/modules/HuntingLicenses/LicenseOrderCopy/LicenseOrderCopyShow.vue';
import LicenseOrderReportShow from '@/modules/HuntingLicenses/LicenseOrderReport/LicenseOrderReportShow.vue';

const Licenses = () => import(/* webpackChunkName: "HuntingLicenses" */ 'RootDir/modules/HuntingLicenses/LicenseOrder/List.vue');

const LicensesCopy = () => import(/* webpackChunkName: "HuntingLicensesCopy" */ 'RootDir/modules/HuntingLicenses/LicenseOrderCopy/List.vue');

const LicensesReport = () => import(/* webpackChunkName: "HuntingLicenseReport" */ 'RootDir/modules/HuntingLicenses/LicenseOrderReport/List.vue');

const Applications = () => import(/* webpackChunkName: "Applications" */ 'RootDir/modules/HuntingLicenses/LicenseApproval/List.vue');

export default [
  {
    path: 'license/list',
    name: 'hunting-licenses-order-list',
    component: Licenses,
  },
  {
    path: 'license/list/:orderId',
    name: 'hunting-licenses-order-show',
    component: ShowOrder,
    props: true,
  },
  {
    path: 'license-copy/list',
    name: 'hunting-licenses-order-copy-list',
    component: LicensesCopy,
  },
  {
    path: 'license-copy/list/:orderId',
    name: 'hunting-licenses-order-copy-show',
    component: LicenseOrderCopyShow,
    props: true,
  },
  {
    path: 'license-report/list',
    name: 'hunting-licenses-order-report-list',
    component: LicensesReport,
  },
  {
    path: 'license-report/list/:orderId',
    name: 'hunting-licenses-order-report-show',
    component: LicenseOrderReportShow,
    props: true,
  },
  {
    path: 'approve/list',
    name: 'hunting-licenses-list',
    component: Applications,
  },
];
